<template>
  <div class="login-wrapper d-flex align-items-center justify-content-center">
    <div class="login-card card shadow-lg p-4">
      <!-- Botón Volver -->
      <div class="mb-3">
        <button class="btn btn-outline-secondary btn-sm" @click="$router.push('/bienvenida')" aria-label="Volver al inicio">
          <font-awesome-icon icon="arrow-left" class="me-2" />
          Volver al inicio
        </button>
      </div>

      <div class="text-center mb-4">
        <h2 class="fw-bold">Iniciar Sesión</h2>
        <p class="text-muted">Accede a tu cuenta</p>
      </div>

      <!-- ⚠️ Alerta de error -->
      <div v-if="errorMessage" class="alert alert-danger d-flex align-items-center gap-2" role="alert">
        <font-awesome-icon icon="exclamation-triangle" />
        <span class="flex-grow-1">{{ errorMessage }}</span>
        <button type="button" class="btn-close" @click="errorMessage = ''" aria-label="Cerrar"></button>
      </div>

      <form @submit.prevent="login">
        <div class="mb-3">
          <label for="email" class="form-label">Correo Electrónico</label>
          <input type="email" id="email" v-model="email" class="form-control" placeholder="tuemail@example.com" required />
        </div>

        <div class="mb-3">
          <label for="password" class="form-label">Contraseña</label>
          <div class="position-relative">
            <input
              :type="mostrarPassword ? 'text' : 'password'"
              id="password"
              v-model="password"
              class="form-control pe-5"
              placeholder="********"
              required
            />
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary position-absolute top-50 end-0 translate-middle-y me-2"
              @click="mostrarPassword = !mostrarPassword"
              tabindex="-1"
            >
              <font-awesome-icon :icon="['fas', mostrarPassword ? 'eye-slash' : 'eye']" />
            </button>
          </div>
        </div>

        <button type="submit" class="btn btn-primary w-100">Iniciar Sesión</button>
      </form>

      <div class="text-center mt-3">
        <p class="text-muted">¿No tienes una cuenta?
          <router-link to="/register" class="fw-bold">Regístrate</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  name: 'UserLogin',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      mostrarPassword: false, // ✅ Agregado para que funcione el botón
    };
  },
  methods: {
    async login() {
      this.errorMessage = '';
      try {
        const response = await axios.post('/api/auth/login', {
          email: this.email,
          password: this.password,
        }, {
          headers: { 'X-Is-Login': 'true' }
        });

        const user = response.data?.result?.user;
        const token = response.data?.result?.token;

        if (token && user) {
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          this.$store.commit('setUsuarioActual', user);

          if (user.club) {
            localStorage.setItem('club', JSON.stringify(user.club));
            this.$store.commit('setClubActual', user.club);
            if(user.club.proyectos.length > 0) {
              //buscar un proyecto que tenga un evento_cultivo 
              const proyecto = user.club.proyectos.find(p => p.evento_cultivo);
              if(proyecto) {
                this.$store.commit('setProyectoActual', proyecto);
                this.$store.commit('limpiarEventoActual');
                this.$store.commit('setEventoActual', proyecto.evento_cultivo);
              }
            }
          } else {
            localStorage.setItem('club', JSON.stringify({}));
          }

          this.$router.push('/');
        } else {
          this.errorMessage = 'Credenciales incorrectas o datos incompletos.';
        }
      } catch (error) {
        const msg = error?.response?.data?.message || 'Error desconocido';
        console.error('Error al iniciar sesión:', msg);
        this.errorMessage = msg;
      }
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4f8, #ffffff);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  border: none;
  border-radius: 12px;
  background-color: #fff;
}
</style>
